import React from 'react';
import UpdateBookmarkPage from '../updateUserProject';
var DenyUserProjectPage = function() {
    return /*#__PURE__*/ React.createElement(UpdateBookmarkPage, {
        status: "rejected"
    });
};
export default DenyUserProjectPage;
